module.exports = __webpack_public_path__ + "static/media/mataKaihei.a9c739fd.png";